import { render, staticRenderFns } from "./child-list.vue?vue&type=template&id=4639fb9c&"
import script from "./child-list.vue?vue&type=script&lang=js&"
export * from "./child-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports